"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TDNode = exports.TransientData = exports.TDNodeType = void 0;
var TDPath_1 = require("./TDPath");
var StringUtil_1 = require("./core/StringUtil");
var LangUtil_1 = require("./core/LangUtil");
var TDNodeProxyHandler_1 = require("./TDNodeProxyHandler");
var TDNodeType;
(function (TDNodeType) {
    TDNodeType[TDNodeType["MAP"] = 0] = "MAP";
    TDNodeType[TDNodeType["ARRAY"] = 1] = "ARRAY";
    TDNodeType[TDNodeType["SIMPLE"] = 2] = "SIMPLE";
})(TDNodeType = exports.TDNodeType || (exports.TDNodeType = {}));
var KEY_REF = '$ref';
var TransientData = /** @class */ (function () {
    function TransientData() {
    }
    return TransientData;
}());
exports.TransientData = TransientData;
var TDNode = /** @class */ (function () {
    // Create a root node if parent is undefined
    function TDNode(doc, key) {
        this.doc = doc;
        this.key = key;
        this.type = TDNodeType.SIMPLE;
        /** The value of the node, only available for leave node */
        this.mValue = null;
        /** indicate this node is a deduped Array node for textproto which allows duplicated keys */
        this.deduped = false;
        // transient properties
        this.tData = new TransientData();
    }
    TDNode.prototype.clone = function () {
        var result = new TDNode(this.doc, this.key).setType(this.type).setValue(this.value);
        result.parent = this.parent;
        result.children = this.children;
        result.start = this.start;
        result.end = this.end;
        result.deduped = this.deduped;
        return result;
    };
    TDNode.prototype.cloneOfSimpleType = function (value) { return new TDNode(this.doc, this.key).setParent(this.parent).setType(TDNodeType.SIMPLE).setValue(value); };
    TDNode.prototype.setParent = function (parent) { this.parent = parent; return this.touch(); };
    TDNode.prototype.setKey = function (key) { this.key = key; return this.touch(); };
    TDNode.prototype.setValue = function (val) { this.mValue = val; return this.touch(); };
    Object.defineProperty(TDNode.prototype, "value", {
        get: function () { return this.mValue; },
        set: function (value) { this.mValue = value; },
        enumerable: false,
        configurable: true
    });
    TDNode.prototype.setType = function (type) { this.type = type; return this; };
    TDNode.prototype.setStart = function (start) { this.start = start; return this; };
    TDNode.prototype.setEnd = function (end) { this.end = end; return this; };
    TDNode.prototype.createChild = function (name) {
        var childIndex = this.indexOf(name);
        if (childIndex < 0) {
            var cnode = new TDNode(this.doc, name);
            this.addChild(cnode);
            return cnode;
        }
        // special handling for textproto due to its bad design that allows duplicated keys
        var existNode = this.children[childIndex].clone();
        if (!existNode.deduped) {
            var listNode = new TDNode(this.doc, name);
            listNode.parent = this;
            listNode.deduped = true;
            listNode.type = TDNodeType.ARRAY;
            this.children[childIndex] = listNode;
            existNode.key = '0';
            listNode.addChild(existNode);
            listNode.start = existNode.start; // Reuse first node's start and length
            listNode.end = existNode.end;
            existNode = listNode;
        }
        return existNode.createChild();
    };
    TDNode.prototype.addChild = function (node) {
        if (!this.children)
            this.children = [];
        node.parent = this;
        node.doc = this.doc;
        if (node.key == null) // Assume it's array element
            node.key = "" + this.getChildrenSize();
        this.children.push(node);
        if (this.tData.nameIndex != null)
            this.tData.nameIndex.set(node.key, this.children.length - 1);
        else if (this.children.length > TDNode.SIZE_TO_INIT_NAME_INDEX)
            this.initNameIndex();
        return this.touch();
    };
    TDNode.prototype.initNameIndex = function () {
        this.tData.nameIndex = new Map();
        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            if (child.key != null)
                this.tData.nameIndex.set(child.key, i);
        }
    };
    TDNode.prototype.getChild = function (name) {
        if (typeof name === 'string')
            name = this.indexOf(name);
        return this.hasChildren() && name >= 0 ? this.children[name] : null;
    };
    TDNode.prototype.indexOf = function (name) {
        if (this.tData.nameIndex != null)
            return LangUtil_1.LangUtil.orElse(this.tData.nameIndex.get(name), -1);
        // VUETIPS: When VueJS instrument this object, it will generate getter to register the dep-graph.
        // Every call to getter could be very heavy if the number of children is huge e.g. > 10000.
        // If we put the this.children inside for loop, it will cause O(n^2) problem.
        // so we have to cache it outside the for loop.
        // Relevant code: reactiveGetter (vue.runtime.esm.js?2b0e:1031)
        var children = this.children;
        if (!children || name == null)
            return -1;
        for (var i = 0; i < children.length; i++)
            if (name === children[i].key)
                return i;
        return -1;
    };
    TDNode.prototype.getChildValue = function (name) {
        var cn = this.getChild(name);
        return cn == null ? null : cn.value;
    };
    TDNode.prototype.hasChildren = function () {
        return this.children && this.children.length > 0;
    };
    TDNode.prototype.getChildrenSize = function () {
        return !this.children ? 0 : this.children.length;
    };
    TDNode.prototype.getValueByPath = function (path) {
        var cn = this.getByPath(path);
        return cn && cn.value;
    };
    /** If noNull is true, it will return the last matched node */
    TDNode.prototype.getByPath = function (path, noNull, idx) {
        if (noNull === void 0) { noNull = false; }
        if (idx === void 0) { idx = 0; }
        if (!(path instanceof TDPath_1.TDPath))
            path = TDPath_1.TDPath.parse(path);
        if (idx === path.parts.length)
            return this;
        var next = this.getNextNode(path.parts[idx]);
        if (next == null)
            return noNull ? this : null;
        return next.getByPath(path, noNull, idx + 1);
    };
    TDNode.prototype.getNextNode = function (part) {
        switch (part.type) {
            case TDPath_1.PathPartType.ROOT:
                return this.doc.root;
            case TDPath_1.PathPartType.CHILD_OR_ID:
                return this.getChild(part.key) || this.doc.idMap[part.id];
            case TDPath_1.PathPartType.RELATIVE:
                return this.getAncestor(part.level);
            case TDPath_1.PathPartType.CHILD:
                return this.getChild(part.key);
            default:
                return null; // Impossible
        }
    };
    TDNode.prototype.getAncestor = function (level) {
        var result = this;
        for (var i = 0; i < level && result != null; i++, result = result.parent || null)
            ;
        return result;
    };
    TDNode.prototype.foreach = function (action) {
        action(this);
        if (this.children != null)
            this.children.forEach(function (n) { return n.foreach(action); });
        return this;
    };
    TDNode.prototype.isRoot = function () {
        return !this.parent;
    };
    /** JS specific logic */
    TDNode.prototype.toObject = function (includeTdNode, useCache) {
        if (includeTdNode === void 0) { includeTdNode = false; }
        if (useCache === void 0) { useCache = true; }
        if (this.tData.obj !== undefined && useCache)
            return this.tData.obj;
        switch (this.type) {
            case TDNodeType.SIMPLE:
                return this.value;
            case TDNodeType.MAP: {
                var result = includeTdNode ? { $$tdNode: this } : {};
                if (useCache)
                    this.tData.obj = result;
                return this.toObjectMap(result, includeTdNode);
            }
            case TDNodeType.ARRAY: {
                var result_1 = [];
                if (useCache)
                    this.tData.obj = result_1;
                if (includeTdNode)
                    result_1.$$tdNode = this;
                if (this.children)
                    this.children.forEach(function (c) { return result_1.push(c.toObject(includeTdNode)); });
                return result_1;
            }
            default:
                throw new Error('Unknown type');
        }
    };
    TDNode.prototype.toObjectMap = function (result, includeTdNode) {
        var _a;
        var refVal = this.getChildValue(KEY_REF);
        if (typeof refVal === 'string') {
            var target = this.getByPath(refVal);
            if (target !== null)
                return target.toObject(includeTdNode);
            console.warn("Reference is not found: ref:" + refVal + "; current Node:" + this.pathAsString);
        }
        (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function (c) { return c.key && (result[c.key] = c.toObject(includeTdNode)); });
        return result;
    };
    TDNode.prototype.toProxy = function (useCache) {
        if (useCache === void 0) { useCache = true; }
        if (useCache && this.tData.proxy)
            return this.tData.proxy;
        var res = new Proxy(this, new TDNodeProxyHandler_1.TDNodeProxyHandler(useCache));
        // res.toString = this.toString;  // Without this, the proxy.toString will return 
        if (useCache)
            this.tData.proxy = res;
        return res;
    };
    Object.defineProperty(TDNode.prototype, "pathAsString", {
        get: function () {
            return '/' + this.path.join('/');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TDNode.prototype, "path", {
        get: function () {
            return this.parent ? __spreadArrays(this.parent.path, [this.key]) : [];
        },
        enumerable: false,
        configurable: true
    });
    TDNode.prototype.isLeaf = function () {
        return this.getChildrenSize() === 0;
    };
    TDNode.prototype.touch = function () {
        this.tData.hash = undefined;
        this.tData.str = undefined;
        this.tData.proxy = undefined;
        this.tData.obj = undefined;
        if (this.parent != null)
            this.parent.touch();
        return this;
    };
    TDNode.prototype.toString = function () {
        if (this.tData.str === undefined)
            this.tData.str = this.toStringInternal('', false);
        return this.tData.str;
    };
    /** method specific for JSON.stringify() */
    TDNode.prototype.toJSON = function () { return this.toStringInternal('', false); };
    TDNode.prototype.toStringInternal = function (sb, includeRootKey, includeReservedKeys, limit) {
        if (includeRootKey === void 0) { includeRootKey = true; }
        if (includeReservedKeys === void 0) { includeReservedKeys = true; }
        if (limit === void 0) { limit = 100000; }
        if (this.parent != null && this.parent.type === TDNodeType.MAP && includeRootKey)
            sb += this.key + ': ';
        if (this.value !== null && this.value !== undefined) {
            if (typeof this.value !== 'string' || !includeRootKey) {
                sb += this.value;
            }
            else {
                var str = StringUtil_1.StringUtil.cEscape(this.value, '\'');
                var remainLen = limit - sb.length;
                if (str.length > remainLen)
                    str = str.substring(0, remainLen) + "...";
                sb += '\'' + str + '\'';
            }
        }
        if (this.children == null)
            return sb;
        sb += this.type === TDNodeType.ARRAY ? '[' : '{';
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var n = _a[_i];
            if (!includeReservedKeys && n.key && n.key.startsWith("$"))
                continue;
            if (sb.length > limit) {
                sb += '...';
                break;
            }
            sb = n.toStringInternal(sb, true, includeReservedKeys, limit);
            if (n !== this.children.slice(-1)[0])
                sb += ", ";
        }
        sb += this.type === TDNodeType.ARRAY ? ']' : '}';
        return sb;
    };
    TDNode.prototype.childrenValueAsList = function () {
        return !this.children ? [] : this.children.map(function (c) { return c.value || c; });
    };
    TDNode.prototype.childrenValueAsListOfList = function () {
        return !this.children ? [] : this.children.map(function (c) { return c.childrenValueAsList(); });
    };
    TDNode.prototype.childrenValueAsListWithKeys = function (keys, target) {
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var k = keys_1[_i];
            if (k === TDNode.COLUMN_KEY)
                continue;
            if (k === TDNode.COLUMN_VALUE && this.type === TDNodeType.SIMPLE)
                target.push(this.value);
            else {
                var c = this.getChild(k);
                target.push((c === null || c === void 0 ? void 0 : c.value) || c);
            }
        }
        return target;
    };
    TDNode.prototype.childrenValueAsListOfListWithKeys = function (keys) {
        return !this.children ? [] :
            this.children.map(function (c) { return c.childrenValueAsListWithKeys(keys, keys[0] === TDNode.COLUMN_KEY ? [c.key] : []); });
    };
    /** Get union of keys for all children, it's used for represent children in a table view */
    TDNode.prototype.getChildrenKeys = function () {
        var result = [];
        var keySet = new Set();
        if (this.type === TDNodeType.SIMPLE || !this.children)
            return result;
        // Add the key column
        result.push(TDNode.COLUMN_KEY);
        keySet.add(TDNode.COLUMN_KEY);
        var hasValue = false;
        for (var _i = 0, _a = this.children; _i < _a.length; _i++) {
            var c = _a[_i];
            if (c.value != null)
                hasValue = true;
            if (c.children)
                for (var _b = 0, _c = c.children; _b < _c.length; _b++) {
                    var cc = _c[_b];
                    if (!keySet.has(cc.key)) {
                        result.push(cc.key);
                        keySet.add(cc.key);
                    }
                }
        }
        if (hasValue)
            result.splice(1, 0, TDNode.COLUMN_VALUE);
        return result;
    };
    // JS Specific
    TDNode.prototype.freeze = function () {
        var children = this.children;
        if (children) {
            for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                var c = children_1[_i];
                c.freeze();
            }
        }
        Object.freeze(this.start);
        Object.freeze(this.end);
        Object.freeze(this.doc);
        Object.freeze(this);
    };
    TDNode.SIZE_TO_INIT_NAME_INDEX = 64;
    TDNode.ID_KEY = "$id";
    TDNode.REF_KEY = "$ref";
    TDNode.COLUMN_KEY = "@key";
    TDNode.COLUMN_VALUE = "@value";
    return TDNode;
}());
exports.TDNode = TDNode;
//# sourceMappingURL=TDNode.js.map